<ph-stack gap="tight">
    <ph-toolbar nowrap>
        <ph-label>{{ section.label }}</ph-label>
        <ph-badge class="ap-recipients-count" variant="light" color="gray" size="small">{{ selectionCount }} {{ selectionCount === 1 ? 'recipient' : 'recipients' }}</ph-badge>
    </ph-toolbar>

    <ph-alert *ngIf="section.note" status="information" variant="lighter" size="small">{{ section.note }}</ph-alert>

    <app-people-picker
        [preselectedPersonIds]="existingPersonIds"
        [allowFreeformEmail]="true"
        [maxSelections]="0"
        placeholder="Search people or type an email…"
        (selectionsChange)="onSelectionChange($event)">
    </app-people-picker>

    <ph-hint class="ap-recipients-overflow" *ngIf="overflowCount > 0">+{{ overflowCount }} more not shown. They are already included.</ph-hint>
</ph-stack>
